module.exports = __webpack_public_path__ + "img/Feature.4a8d82a0.png";